import { render, staticRenderFns } from "./TableShareExp.vue?vue&type=template&id=3a98fdc0&scoped=true"
import script from "./TableShareExp.vue?vue&type=script&lang=js"
export * from "./TableShareExp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a98fdc0",
  null
  
)

export default component.exports